import profiles from 'constants/profiles';
import { highAccessUserTypes, userType } from 'constants/userAccess';

function isPrivilegedUserEmail(userEmail) {
  return userEmail && !!userEmail.match(/@mobiauto.com.br|@grupopan.com/g);
}

export const SAGA_GROUPS = [
  23,
  35,
  64,
  142,
  157,
  947,
  948,
  959,
  966,
  1020,
  1018,
  2093,
  1013,
  2094,
  1015,
];

function checkUserHaveEspecialAccessOrPermission(
  root,
  currentUserType,
  userProfiles,
  userProfile
) {
  // * IF CURRENT USER IS A CONSULTANT
  if (root?.onlyConsultant) {
    return userProfile === profiles.CONSULTOR ? root : false;
  }
  if (userProfile === profiles.CONSULTOR) return root;

  // * CHECK IF USER HAS HIGH/SPECIAL ACCESS
  if (root?.someOwner) {
    const isOwner = [userType.OWNER.name].includes(currentUserType);
    return isOwner ? root : false;
  }

  const allAccess = [
    ...highAccessUserTypes,
    ...(root?.extraUserTypeAccess || []),
  ];

  if (allAccess.includes(currentUserType)) return root;

  // * CHECK USER HAS PERMISSION BY PROFILES
  if (root?.permission && userProfiles?.includes(root.permission)) {
    return root;
  }

  return false;
}

function buildMenuTree(
  tree,
  products,
  currentUserType,
  userProfile,
  userProfiles,
  userEmail,
  financingBancoPanEnabled,
  currentDealerGroupId
) {
  return tree.filter(root => {
    if (root?.children) {
      const childrenFiltered = buildMenuTree(
        root.children,
        products,
        currentUserType,
        userProfile,
        userProfiles,
        userEmail,
        financingBancoPanEnabled,
        currentDealerGroupId
      );
      root.children = childrenFiltered;
    }

    // * IF DEALER IS SAGA OR PRIMEIRA MAO
    if (root?.onlySaga) {
      return SAGA_GROUPS.includes(Number(currentDealerGroupId)) ? root : false;
    }

    // * IF CURRENT USER CONSULTANT
    if (root?.onlyConsultant) {
      return userProfile === profiles.CONSULTOR ? root : false;
    }

    // * CHECK IF DEALER HAS 'BANCO PAN' ENABLED SOME USED IN 'LEAD QUALIFIER'
    if (root?.financingBancoPanEnabled) {
      return financingBancoPanEnabled ? root : false;
    }

    // * ITEM HAVE PRODUCTS TO ACCESS
    if (root?.products) {
      // * CHECK DEALER HAVE PRODUCT
      const hasProduct = products?.find(product => {
        return root?.products.includes(product.type);
      });

      if (hasProduct) {
        // * IF USER HAS A PRIVILEGED EMAIL
        if (root?.enableToPrivilegedEmail && isPrivilegedUserEmail(userEmail)) {
          return root;
        }

        // * CHECK IF ITEM NEED USER SPECIAL ACCESS
        const hasSpecialAccess = root?.extraUserTypeAccess || root?.permission;

        if (hasSpecialAccess) {
          return checkUserHaveEspecialAccessOrPermission(
            root,
            currentUserType,
            userProfiles,
            userProfile
          );
        }
        return root;
      }

      return false;
    }

    // * ITEM HAVE PRODUCT TO ACCESS
    if (root?.product) {
      // * CHECK DEALER HAS PRODUCT
      const hasProduct = products?.find(product => {
        return product.type === root.product;
      });

      if (hasProduct) {
        // * IF USER HAS A PRIVILEGED EMAIL
        if (root?.enableToPrivilegedEmail && isPrivilegedUserEmail(userEmail)) {
          return root;
        }

        // * CHECK TO ITEM NEED USER ESPECIAL ACCESS
        const hasSpecialAccess = root?.extraUserTypeAccess || root?.permission;

        if (hasSpecialAccess) {
          return checkUserHaveEspecialAccessOrPermission(
            root,
            currentUserType,
            userProfiles,
            userProfile
          );
        }
        return root;
      }

      return false;
    }

    if (root?.enableToPrivilegedEmail && isPrivilegedUserEmail(userEmail)) {
      return root;
    }

    if (root?.someOwner) {
      const isOwner = [userType.OWNER.name].includes(currentUserType);
      return isOwner ? root : false;
    }

    const hasSpecialAccess = root?.extraUserTypeAccess || root?.permission;

    if (hasSpecialAccess) {
      return checkUserHaveEspecialAccessOrPermission(
        root,
        currentUserType,
        userProfiles,
        userProfile
      );
    }

    return root;
  });
}

export default buildMenuTree;
